import { atom } from 'recoil';

export const emailLogState = atom({
  key: 'email_log_state',
  default: {
    items: [],
    desc: null,
    order_by: null,
    total: null,
    size: 20,
    page: 1,
    screen: null,
    search_text: '',
    appeal_status: '',
  },
});
